module.exports = __webpack_public_path__ + "img/zero-percent-gauge.939da0a8.png";